import React, { Component } from 'react';
import Select from 'react-select';
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import axios from "axios";
import Swal from "sweetalert2";
import { decodeData } from '../../Constants/constants';

class HeadesAndStatutory extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);

    // Initial state to store form data and validation errors
    this.state = {
      name_As_Per_Bank_Record: '',
      enter_Bank_Name: '',
      account_Number: '',
      branch_Name: '',
      IFSC_code: '',
      account_Type: '',
      salary_Mode_Of_Trasfer: '',
      company_salary_statutory_rows: [],
      salary_heads_rows: [],
      errors: {}, // Store validation errors
      decodedData: [],
    };
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetList();
      this.GetSalaryStatutoryList();
      this.GetSalaryHeadList();
    });
  }
  componentDidUpdate(prevProps, prevState) {
          if (prevState.permissions !== this.context.permissions) {
            // console.log("Permissions Updated:", this.context.permissions);
              const { permissions } = this.context;
              if (permissions.length > 0) {
                const queryParams = new URLSearchParams(window.location.search);
                const encodedData = queryParams.get("abs");
                const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                  this.setState({ decodedData });
                }
              } else {
                console.warn("Permissions not yet available. Retrying...");
              }
          }
  }

  // Handler function for form submission
  handleSubmit = (e) => {
    e.preventDefault();
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const employee_id = this.props.params.employee_id;
    var formData = {
      name_As_Per_Bank_Record: this.state.name_As_Per_Bank_Record,
      enter_Bank_Name: this.state.enter_Bank_Name,
      account_Number: this.state.account_Number,
      branch_Name: this.state.branch_Name,
      IFSC_code: this.state.IFSC_code,
      account_Type: this.state.account_Type,
      salary_Mode_Of_Trasfer: this.state.salary_Mode_Of_Trasfer,
    }
    console.log(formData);
    axios.post(`${apiURL}Employees/UpdateBankDetails`, formData, { headers }).then((response) => {
      console.log(response);

      const { success } = response.data;
      if (success === true) {
        this.setState({
          name_As_Per_Bank_Record: '',
          enter_Bank_Name: '',
          account_Number: '',
          branch_Name: '',
          IFSC_code: '',
          account_Type: '',
          salary_Mode_Of_Trasfer: '',
        })

        this.setState({ loadingList: true }, (prevState) => {
          this.GetList();
        })
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          timer: 2000,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
      } else {
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          timer: 2000,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        this.setState({ loadingList: true }, (prevState) => {
          this.GetList();
        })
      }

    })
  };
  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}Employees/GetEmployeeQualifications`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };
  handleDelete = (id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ status: true });
        const formData = {
          employee_qualification_id: id,
        };
        axios
          .post(`${apiURL}Employees/DeleteEmployeeQualification`, formData, { headers })
          .then((response) => {
            Swal.fire({
              title: `<strong>${response.data.success === true ? "Success" : "Failed"
                }</strong>`,
              text: response.data.message,
              icon: response.data.success === true ? "success" : "error",
            });
            this.setState({ status: false });
            if (response.data.success === true) {
              this.setState({ loadingList: true }, (prevState) => {
                this.GetList();
              });
            }
          })
          .catch((error) => {
            // Handle any errors that occur during the request
            Swal.fire({
              title: <strong>Error</strong>,
              html: error,
              icon: "error",
            });
          });
      }
    });
  };
  // Handler function to update state on input change
  handleInputChange = (e) => {
    const { name, value } = e.target;

    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };

  // Handler function for Select component change
  handleSelectChange = (name, selectedOption) => {
    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };
  GetSalaryHeadList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Masters/GetSalaryHeadList`, { headers }).then((response) => {
      var data = response.data;
      if (response.data.success === true) {
        this.setState({
          salary_heads_rows: data.data.map((row) => ({
            value: row.company_salary_head_id,
            label: row.company_salary_head,
            amount: row.company_default_value,
          }))
        });
      }
    });
  }

  GetSalaryStatutoryList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Masters/GetSalaryStatutoryList`, { headers }).then((response) => {
      var data = response.data;
      if (response.data.success === true) {
        this.setState({
          company_salary_statutory_rows: data.data.map((row) => ({
            value: row.company_salary_statutory_id,
            label: row.company_salary_statutory_title,
            company_salary_statutory_ids: row.company_salary_statutory_ids,
            company_salary_statutory_employee_contribution: row.company_salary_statutory_employee_contribution,
            company_salary_statutory_employer_contribution: row.company_salary_statutory_employer_contribution,
            company_salary_statutory_calculate_upto: row.company_salary_statutory_calculate_upto
          }))
        });
      }
    });
  }

  handleStatutoryTypeChange = (selectedOption) => {
    this.setState({
      statutoryType: selectedOption,
      employee_contribution: selectedOption.company_salary_statutory_employer_contribution,
      employer_contribution: selectedOption.company_salary_statutory_employee_contribution
    });

  };
  handleTypeChange = (selectedOption) => {
    // Extract the necessary data from the selected option
    const { value: company_salary_head_id } = selectedOption;

    // Update the state with the selected company_salary_head_id
    this.setState({
      // selectedSalaryType: selectedOption,
      company_salary_head_id,
      // company_salary_head_id: selectedOption.company_salary_head_id,
      amount: selectedOption.amount,
    });
  };

  render() {
    const { errors } = this.state;

    return (
      <>
        <div>
          <div>
            <h5>
              Heads And Statutory {" "}
              <span
                style={{
                  color: "blue",
                  borderRadius: "50%",
                  background: "#f0f8ff",
                  padding: "2px 6px",
                  display: "inline-block",
                  textAlign: "center",
                  width: "20px",
                  height: "20px",
                  lineHeight: "20px",
                }}
              >
                *
              </span>
            </h5>
            <p className="text-muted">
              Fill all information below
            </p>
          </div>
           </div>
           <div>
          <p className="mb-0 h6">Statutory contributions Type</p>
          <div className="py-3 mb-3 d-flex justify-content-between align-items-center">
            <div className="w-25">
          <Select options={this.state.salary_heads_rows} onChange={this.handleTypeChange} />
          </div>
          </div>
        </div>
        <div>
          <p className="mb-0 h6">Statutory contributions Type</p>
          <div className="py-3 mb-3 d-flex justify-content-between align-items-center">
            <div className="w-25">
              <Select options={this.state.company_salary_statutory_rows} onChange={this.handleStatutoryTypeChange} />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(HeadesAndStatutory);
